export default "__VITE_ASSET__DfoaDFXS__"